import React, {Component} from "react";
import {Button, Modal, Form, Row, Col} from "react-bootstrap";
import "./Modal.css";
import ReactLoading from "react-loading";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTimes} from "@fortawesome/free-solid-svg-icons";
export default class AscModal extends Component {
    // get modal title
    getTitle = (type) => {
        let returnObj = {title: null, okBtnDisplayFlg: true};

        switch (this.props.state.modalType) {
            case "insert":
            case "create":
                returnObj.title = (type === "title") ? this.props.langText.Body.InsertTitle : this.props.langText.Body.Insert;
                break;
            case "vocAnalysis":
                returnObj.title = (type === "title") ? this.props.langText.Body.VocAnalysis : this.props.langText.Body.Create;
                break;
            case "update":
                returnObj.title = (type === "title") ? this.props.langText.Body.UpdateTitle : this.props.langText.Body.Update;
                break;
            case "delete":
                returnObj.title = (type === "title") ? this.props.langText.Body.DeleteTitle : this.props.langText.Body.Delete;
                break;
            case "read":
                returnObj.title = this.props.langText.Body.ReadTitle;
                returnObj.okBtnDisplayFlg = false;
                break;
            case "setting":
                returnObj.title = this.props.langText.Body.Set;
                break;
            case "playback":
                returnObj.title = this.props.langText.Body.PlayBack;
                returnObj.okBtnDisplayFlg = false;
                if (this.props.currentPermission.delete) {
                    returnObj.customDeleteBtn = true;
                }
                if (this.props.state && this.props.state.ht87_voice_log_to_text 
                    && this.props.currentPermission.download) {
                    returnObj.getCallTextDownloadBtn = true;
                }
                if (this.props.onCategoryEdit) {
                    returnObj.getCategoryEditBtn = true;
                }
                break;
            case "unify":
                returnObj.title = (type === "title") ? (this.props.langText.Body.PhoneBookInfo || "電話番号重複") : "結合";
                returnObj.okBtnDisplayFlg = true;
                break;
            default:
        }

        return returnObj;
    }

    customDLBtn = () => {
        let result = this.getTitle("ok");
        if (result.okBtnDisplayFlg) {
            return (
                <>
                <Button
                    className = 'ok-execute'
                    onClick = {this.props.onClick(this.props.state.modalType)}
                    variant = {this.props.state.modalType !== "delete" ? "primary" : "danger"}
                    disabled = {!this.props.validationHandle(this.props.state.modalType)}>
                    {result.title}
                </Button>
                {this.props.state.DownloadData}
                </>
            );
        } else {
            return null;
        }
    }

    getOkBtn = () => {
        let result = this.getTitle("ok");
        if (result.okBtnDisplayFlg) {
            return (
                <Button
                    className = 'ok-execute'
                    onClick = {this.props.onClick(this.props.state.modalType)}
                    variant = {this.props.state.modalType !== "delete" ? "primary" : "danger"}
                    disabled = {!this.props.validationHandle(this.props.state.modalType)}>
                    {result.title}
                </Button>
            );
        } else {
            return null;
        }
    }

    getCancelBtn = () => {
        return (
            <Button
                className = 'cancel-execute'
                onClick = {e => this.props.modalClose ? this.props.modalClose() : this.props.propSetState({show: false})}
                variant = 'outline-secondary'
            >
                {this.props.langText.Body.Cancel}
            </Button>
        );
    }

    getXBtn = () => {
        return (
            <Button
                className = 'x-execute'
                onClick = {e => this.props.modalClose ? this.props.modalClose() : this.props.propSetState({show: false})}
            >
                <FontAwesomeIcon icon={faTimes}/>
            </Button>
        );
    }

    customDeleteBtn () {
        return (
            <Button
                className = "custom-delete"
                onClick = {e => this.props.onClick("voiceDelete")}
            >
                {this.props.langText.Body.Delete}
            </Button>
        );
    }

    getCallTextDownloadBtn () {
        let result = this.getTitle("playback");
        if (result.getCallTextDownloadBtn) {
            return (
                <Button
                    className="call-text-download-btn"
                    onClick={e => this.props.onClick("callTextDownload")}
                >
                    {this.props.langText.Body.callTextDownload}
                </Button>
            );
        } else {
            return null;
        }
    }

    getCategoryEditBtn () {
        let result = this.getTitle("playback");
        if (result.getCategoryEditBtn) {
            return (
                <Button
                    className="category-edit-btn"
                    onClick={e => this.props.onCategoryEdit()}
                >
                    {this.props.langText.Body.CallCategoryEdit}
                </Button>
            );
        } else {
            return null;
        }
    }

    // 表示可否は呼び出し元(Footer)で this.props.onVoiceRetry の有無により判定済みのため、
    // ここでは getTitle の再チェックを行わずボタンを返す。
    getVoiceRetryBtn () {
        return (
            <Button
                className="voice-retry-btn"
                onClick={() => this.props.onVoiceRetry()}
            >
                {this.props.langText.Body.VoiceRetry}
            </Button>
        );
    }

    modalLoadingDisplay = () => {
        if (this.props.state.loadingDisplayFlag) {
            return(
                <div className="asc-block-ui">
                    <div className="asc-block-icon-box">
                        <ReactLoading className="asc-block-icon" type="spinningBubbles" color="#fff" />
                        <label className="asc-block-label">{this.props.langText.Table.LoadingText}</label>
                    </div>
                </div>
            );
        } else {
            return false;
        }
    }

    render() {
        let {
            children,
            state,
            downloadFlag,
            currentPermission
        } = this.props;
        let result = this.getTitle("title");

        return (
            <Modal
                dialogClassName = {this.props.dialogClassName}
                scrollable = "true"
                show = {state.show}
                size = "lg"
                aria-labelledby = "contained-modal-title-lg"
            >
                <Form horizontal="true">
                    {this.modalLoadingDisplay()}
                    <Modal.Header>
                        <Modal.Title>
                            <Row>
                                <Col className="modal-title-text" lg={11} sm={11} xs={11}>
                                    {result.title}
                                </Col>
                                <Col lg={1} sm={1} xs={1}>
                                    <span>{this.getXBtn()}</span>
                                </Col>
                            </Row>
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        {children}
                    </Modal.Body>

                    <Modal.Footer className="card-button">
                        <div className="child-box align-left">
                            {currentPermission && currentPermission.delete ? <span>{this.customDeleteBtn()}</span>: ""}
                            {currentPermission && currentPermission.download ? <span>{this.getCallTextDownloadBtn()}</span>: ""}
                            {this.props.onCategoryEdit
                                ? <span>{this.getCategoryEditBtn()}</span> : ""}
                            {this.props.onVoiceRetry
                                ? <span>{this.getVoiceRetryBtn()}</span> : ""}
                        </div>
                        <div className="child-box align-right">
                            <span>{this.getCancelBtn()}</span>
                            {downloadFlag
                                ?<span>{this.customDLBtn()}</span>
                                :<span>{this.getOkBtn()}</span>
                            }
                        </div>
                    </Modal.Footer>
                </Form>
            </Modal>
        );
    }
}
